import { motion, AnimatePresence, useAnimation } from 'framer-motion';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import PlusIcon from 'components/shared/icons/plus-icon';

const variants = {
  from: {
    opacity: 0,
    height: 0,
    transition: {
      duration: 0.5,
      type: 'tween',
    },
  },
  to: {
    opacity: 1,
    height: 'auto',
    transition: {
      duration: 0.5,
      type: 'tween',
    },
  },
};

const Toggle = ({ children, text, className, buttonClassname, id, isAccordion }) => {
  const [clicked, setIsClicked] = useState(false);
  const controls = useAnimation();

  const handleToggle = (e) => {
    e.target.closest('.toggle-button').classList.toggle('opened');
    setIsClicked((prev) => !prev);
  };
  const handleAccordion = (e) => {
    const id = e.target.closest('.toggle-button').getAttribute('data-id');
    const toggleContent = document.getElementById(id);
    document.querySelectorAll('.toggle-content').forEach((el) => {
      if (el.id !== id) {
        el.classList.remove('max-h-[99999px]');
        el.classList.remove('opacity-100');
        el.classList.add('max-h-0');
        el.classList.add('opacity-0');
      }
    });
    document.querySelectorAll('.toggle-button').forEach((el) => {
      if (el !== e.target.closest('.toggle-button')) {
        el.classList.remove('opened');
      }
    });
    if (toggleContent) {
      toggleContent.classList.toggle('max-h-[99999px]');
      toggleContent.classList.toggle('opacity-100');
      e.target.closest('.toggle-button').classList.toggle('opened');
      if (e.target.closest('.toggle-button').classList.contains('opened')) {
        toggleContent.style.height = `${toggleContent.scrollHeight}px`;
      } else {
        toggleContent.style.height = 0;
      }
    }
  };

  useEffect(() => {
    if (clicked) {
      controls.start('to');
    } else {
      controls.start('from');
    }
  }, [clicked, controls]);

  return (
    <>
      <div className={`relative ${className}`}>
        <button
          className={`toggle-button relative flex items-center gap-10 text-left text-sm font-semibold leading-[1.15] lg:text-base xl:text-[1.375rem] ${buttonClassname} pr-10`}
          type="button"
          {...(id ? { 'data-id': id } : {})}
          onClick={isAccordion ? handleAccordion : handleToggle}
        >
          {text}
          <span className="toggle-icon-plus absolute right-0">
            <PlusIcon
              isMinus={false}
              className="h-[0.75rem] w-[0.75rem] lg:h-[1.15rem] lg:w-[1.15rem]"
            />
          </span>
          <span className="toggle-icon-minus absolute right-0">
            <PlusIcon className="h-[0.75rem] w-[0.75rem] lg:h-[1.15rem] lg:w-[1.15rem]" isMinus />
          </span>
        </button>
      </div>

      {isAccordion ? (
        <div
          className="toggle-content h-0 max-h-0 overflow-hidden opacity-0 transition-all duration-300"
          id={id}
        >
          {children}
        </div>
      ) : (
        <AnimatePresence mode="wait" onExitComplete={() => setIsClicked(false)}>
          {clicked && (
            <motion.div
              variants={variants}
              animate={controls}
              exit="from"
              initial="from"
              className="overflow-hidden"
            >
              {children}
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </>
  );
};

Toggle.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  buttonClassname: PropTypes.string,
  id: PropTypes.string,
  isAccordion: PropTypes.bool,
};

Toggle.defaultProps = {
  className: '',
  buttonClassname: '',
  id: '',
  isAccordion: false,
};

export default Toggle;
